@if (userInfo) {
<header class="main-header">
  @if (shouldShowAppSwitcher) {
  <div>
    <div id="neogov-app-switch-container"></div>
    <div class="main-header__group">
      <div id="mobile-btn" class="mobile-btn" (click)="toggleSidebar()">
        <a360-icon icon="burger-menu" width="25px" height="25px"> </a360-icon>
      </div>
    </div>
  </div>
  } @else {

  <div class="main-header__group">
    <div class="main-header__logo">
      <img class="img" [src]="logoSrc" alt="" />
    </div>
    <div class="main-header__program">
      <div class="txt" title="{{ userInfo.CurrentSite?.Name }}">{{ userInfo.CurrentSite?.Name }}</div>
    </div>
    <div id="mobile-btn" class="mobile-btn" (click)="toggleSidebar()">
      <a360-icon icon="burger-menu" width="25px" height="25px"> </a360-icon>
    </div>
  </div>

  }

  <div class="main-header__group">
    <div class="notification-wrapper main-header__link" (click)="toggleNotifications()" title="Notifications">
      <div class="notification-btn">
        <a360-icon icon="bell"></a360-icon>
        @if (counters.UnreadCount) {
        <div class="notification-label">{{ counters.UnreadCount }}</div>
        }
      </div>
    </div>
    <a class="profile-link main-header__link" (click)="myProfile()" title="Your Profile">
      <a360-avatar class="img" [originalSrc]="userInfo.AvatarSrc" [altDescription]="userInfo.UserName"></a360-avatar>
      <span class="txt">{{ userInfo.UserName }}</span>
    </a>
    <div class="main-header__link power-off-link" (click)="logout()" title="Logout">
      <a360-icon icon="logout"></a360-icon>
    </div>
  </div>
</header>
}
